// extracted by mini-css-extract-plugin
export default {"howPaysWorks":"HowPaysWorks_howPaysWorks__ry6nq","carouselItem":"HowPaysWorks_carouselItem__rTy7k","carouselContainer":"HowPaysWorks_carouselContainer__MSCis"};